module.exports = function() {
  return new Worker(__webpack_public_path__ + "e9dd41002579477150eb.worker.js");
};